import React from 'react'

const Footer = () => {
    const currentYear = new Date().getFullYear();

  return (
    <footer className='pt-5 d-flex justify-content-between'>
        <span>Copyright &copy; {currentYear} Dinbyte Technologies</span>
    </footer>
  )
}

export default Footer